

import React, { useState } from "react";
import DeclinedFoodOrders from "./DeclinedFoodOrders";
import DeclinedDeliveryOrders from "./DeclinedDeliveryOrders";


const DeclinedOrders = () => {
  const [activeTab, setActiveTab] = useState("Delivery orders");

  const DummySection = ({ title }) => (
    <div className="dummy-box">
      <h2>{title}</h2>
      <p>This is a dummy section for <strong>{title}</strong>.</p>
      <span>Content will be added later 🚧</span>
    </div>
  );

  const renderComponent = () => {
    switch (activeTab) {

      // case "Food orders":
      //   return <DeclinedFoodOrders />;
        case "Delivery orders":
        return <DeclinedDeliveryOrders />;

      default:
        return <DeclinedDeliveryOrders />;
    }
  };

  const tabs = [

    // "Food orders",
    "Delivery orders",

  ];

  return (
    <div className="tabs-wrapper" style={{ width: "77vw" }}>
      {/* TOP ONE-ROW TABS (ALL SCREENS) */}
      <div className="tabs-row">
        {tabs.map((tab) => (
          <span
            key={tab}
            className={`row-tab ${activeTab === tab ? "active" : ""}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </span>
        ))}
      </div>

      {/* CONTENT */}
      <div className="tabs-content">
        {renderComponent()}
      </div>
    </div>
  );
};

export default DeclinedOrders;

